<!--
 * @Author: Ximen
 * @Date: 2021-03-17 14:12:51
 * @LastEditors: Ximen
 * @LastEditTime: 2021-04-07 14:27:45
-->
<template>
  <div class="bg">
    <div style="height:100%">
      <List style="margin-top:258px"/>
      <Detail ref="detail"/>
      <PayModal ref="payModal" :payInfo="payInfo"/>
    </div>
  </div>
</template>

<script lang='ts'>
// import commonApi from '@/api/common';
import { defineComponent } from 'vue';
import { message as $message } from 'ant-design-vue';
import PayModal from '@/components/modal/payModal.vue';
import List from './components/list.vue';
import Detail from './components/modal/detail.vue';

export default defineComponent({
  name: 'PaymentRecord',
  components: {
    List,
    Detail,
    PayModal,
  },
  data() {
    return {
      payInfo: {},
    };
  },
  setup() {
    const error = (str: string) => {
      $message.error(str);
    };
    const success = (str: string) => {
      $message.success(str);
    };
    return {
      error,
      success,
    };
  },
  // mounted() {
  // },
  methods: {
    openDetailModal(item: TObject) {
      const child = this.$refs.detail as unknown as {[x: string]: Function};
      child.showVisible(item);
    },
    handleToPay(item: TObject) {
      const payfo = item;
      payfo.value = item.amount;
      this.payInfo = payfo;
      const refs = this.$refs as unknown as {payModal: {showModal: Function}};
      refs.payModal.showModal();
    },
  },
});
</script>
<style lang="stylus" scoped>
  .bg
    background url('../../assets/background.jpg') no-repeat
    background-size 100% 100%
    width 100%
    min-height 100vh
    overflow: hidden;
    .box
      margin 0 auto
      border-radius 20px
      width 420px
      .title
        font-size 24px
        color #073D7D
        margin-bottom 40px
      .blank
        width 220px
        height auto
        margin-bottom 40px
      .accept-btn
        width 100%
        height 50px
        margin-top 10px
        border-radius 5px
        background #3281DD
        margin-bottom 30px
      .consulting
        font-size 14px
        color #073D7D
</style>
